import React from 'react';
import SeoHero from '../components/SeoHero';
import WhatIsSeoSection from '../components/WhatIsSeoSection';
import WhyNeedSeoSection from '../components/WhyNeedSeoSection';
import SeoFactorsScrollSection from '../components/SeoFactorsScrollSection';
import TechnicalSeoScrollSection from '../components/TechnicalSeoScrollSection';
import OffPageSeoScrollSection from '../components/OffPageSeoScrollSection';
import LocalSeoScrollSection from '../components/LocalSeoScrollSection';
import SeoPortfolioSection from '../components/SeoPortfolioSection';
import SeoServicesTabs from '../components/SeoServicesTabs';
import AwardWinningSeoSection from '../components/AwardWinningSeoSection';
import CrossPlatformSeoSection from '../components/CrossPlatformSeoSection';
import ContactUs from '../components/ContactUs';

function SeoServicesPage() {
  return (
    <>
      <SeoHero />
      <WhatIsSeoSection />
      <WhyNeedSeoSection />
      <SeoFactorsScrollSection />
      <TechnicalSeoScrollSection />
      <OffPageSeoScrollSection />
      <LocalSeoScrollSection />
      <SeoPortfolioSection />
      <SeoServicesTabs />
      <AwardWinningSeoSection />
      <CrossPlatformSeoSection />
      <ContactUs />
    </>
  );
}

export default SeoServicesPage;
